import axios from '@/axios.js';

export const latestVideoApi = {
  getLatestVideos(payload) {
    return axios.get('admin/latest-videos', {
      params: payload,
    });
  },
  getLatestVideo(id) {
    return axios.get(`admin/latest-videos/${id}?join=translations`);
  },
  addLatestVideo(body) {
    return axios.post('admin/latest-videos', body);
  },
  updateLatestVideo(id, body) {
    return axios.patch(`admin/latest-videos/${id}`, body);
  },
  deleteLatestVideo(id) {
    return axios.delete(`admin/latest-videos/${id}`);
  },
};
